import { AnimatePresence, motion } from 'framer-motion';
import Icons from '../../assets/index';

import {
  largeMotionProps,
  mediumMotionProps,
  smallMotionProps,
  veryLargeMotionProps,
} from '../../utils/framerProps';

type PanelProps = {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  title: string;
  subTitle?: string;
  size?: 'small' | 'medium' | 'large' | 'veryLarge';
};

/**
 * `SidePanel` is a component that renders a side panel with animation and overlay.
 */
const SidePanel = ({ isOpen, children, onClose, title, subTitle, size = 'large' }: PanelProps) => {
  let dynamicPropsForSize = mediumMotionProps;

  switch (size) {
    case 'small':
      dynamicPropsForSize = smallMotionProps;
      break;
    case 'large':
      dynamicPropsForSize = largeMotionProps;
      break;
    case 'veryLarge':
      dynamicPropsForSize = veryLargeMotionProps;
      break;
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}

          {/* Panel */}
          <motion.div
            {...dynamicPropsForSize}
            data-testid="panel-container"
            className=" fixed top-0 right-0 z-50 h-full flex flex-col p-5 bg-white shadow-lg"
          >
            <div className="mb-4 flex flex-row items-center justify-between">
              <div>
                <p className="text-ds-mc-blue-900 text-lg font-medium">{title}</p>
                {subTitle && <p className="p-xs-regular-dim">{subTitle}</p>}
              </div>
              <div className="cursor-pointer">
                <span data-testid="panel-close-button" onClick={onClose}>
                  <Icons.closeIcon />
                </span>
              </div>
            </div>
            {children}
          </motion.div>
          <div className={`fixed inset-0 bg-black opacity-50 ${isOpen ? 'block' : 'hidden'}`} />
        </>
      )}
    </AnimatePresence>
  );
};

export default SidePanel;
